import React from 'react';
import { Alert, Box, Button, Paper, Typography } from '@mui/material';
import { Line, Pie, getElementAtEvent } from 'react-chartjs-2';
import { getTrainingClassLabel } from '../../services/trainingClassService';

export default function HomeCharts({
  classPieRef,
  selectedSessionClass,
  setSelectedSessionClass,
  selectedClassActivityChartState,
  activityPieData,
  pieOptions,
  sessionClassChartState,
  classPieData,
  weeklyTrainingChartState,
  weeklyLineData,
  lineOptions,
  trainingClassesByName,
}) {
  return (
    <Box className="home-charts-container">
      <Paper className="chart-card" elevation={1}>
        {selectedSessionClass ? (
          <>
            <Box className="chart-header">
              <Typography variant="h6" component="h2">
                {getTrainingClassLabel(trainingClassesByName, selectedSessionClass)} (Past 2 Weeks)
              </Typography>
              <Button variant="text" onClick={() => setSelectedSessionClass(null)}>
                Back
              </Button>
            </Box>

            {selectedClassActivityChartState.values.length === 0 ? (
              <Alert severity="info" sx={{ mt: 2 }}>
                No activity duration data found for this class in the last 14 days.
              </Alert>
            ) : (
              <Box className="chart-wrapper">
                <Pie
                  data={activityPieData}
                  options={pieOptions}
                  className="home-pie-chart"
                />
              </Box>
            )}
          </>
        ) : (
          <>
            <Typography variant="h6" component="h2">
              Past 2 Weeks
            </Typography>
            {sessionClassChartState.values.length === 0 ? (
              <Alert severity="info" sx={{ mt: 2 }}>
                No session duration data available in the last 14 days.
              </Alert>
            ) : (
              <Box className="chart-wrapper">
                <Pie
                  ref={classPieRef}
                  data={classPieData}
                  options={pieOptions}
                  className="home-pie-chart"
                  onClick={(event) => {
                    const activeElement = getElementAtEvent(classPieRef.current, event)?.[0];
                    if (!activeElement) return;
                    const clickedClass = sessionClassChartState.rawLabels[activeElement.index];
                    setSelectedSessionClass(clickedClass);
                  }}
                />
              </Box>
            )}
          </>
        )}
      </Paper>

      <Paper className="chart-card" elevation={1}>
        <Typography variant="h6" component="h2">
          Weekly Training Time
        </Typography>
        {weeklyTrainingChartState.values.length === 0 ? (
          <Alert severity="info" sx={{ mt: 2 }}>
            No weekly training data available yet.
          </Alert>
        ) : (
          <Box className="chart-wrapper home-line-chart-wrapper">
            <Line data={weeklyLineData} options={lineOptions} className="home-line-chart" />
          </Box>
        )}
      </Paper>
    </Box>
  );
}
